import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'babel-polyfill';

import './index.css';
import { BrowserRouter } from 'react-router-dom';
import Index from './app/layouts/index';
import ScrollToTop from './scrollTop';
import ErrorBoundary from './ErrorBoundary';
import Raven from 'raven-js';




import configureStore from './store';
const initialState = window.__PRELOADED_STATE__;
delete window.__PRELOADED_STATE__;

if (process.env.NODE_ENV !== 'development') {
  let environment = 'production';
  Raven.config('https://1d29c748c57148d0bf30a1eda1dfda68@sentry.io/1263263', {
    // release: "release", @todo: get release version
    environment: environment
  }).install();
}


const store = configureStore(initialState);

ReactDOM.render(
    <Provider store={store}>
        <ErrorBoundary>
            <BrowserRouter>
                <ScrollToTop>
                    <Index />
                </ScrollToTop>
            </BrowserRouter>
        </ErrorBoundary>
    </Provider>
    ,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js